import type { SupabaseClient } from '@supabase/supabase-js';

/** Read the current Supabase session and return a usable access token. */
export async function requireAccessToken(supabase: SupabaseClient): Promise<string> {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;

  const accessToken = data.session?.access_token;
  if (!accessToken) throw new Error('Authentication required');
  return accessToken;
}
